// extracted by mini-css-extract-plugin
export var aboutPeople__bottomText = "mainOld-module--about-people__bottomText--8aa11";
export var aboutPeople__title = "mainOld-module--about-people__title--e78d7";
export var blockBtn = "mainOld-module--block-btn--c907d";
export var blockTitle = "mainOld-module--block-title--757f1";
export var btn = "mainOld-module--btn--a5a32";
export var mainTitle = "mainOld-module--main-title--ac430";
export var mark = "mainOld-module--mark--4c65f";
export var markPurple = "mainOld-module--mark--purple--df7b9";
export var sideData = "mainOld-module--side-data--06bf2";
export var sideData__bigText = "mainOld-module--side-data__big-text--2cefe";
export var sideData__bigTextAccent = "mainOld-module--side-data__big-text--accent--68c5e";
export var sideData__bigTextIndent = "mainOld-module--side-data__big-text--indent--ecab7";
export var sideData__smallText = "mainOld-module--side-data__small-text--49d17";
export var sideData__smallTextUppercase = "mainOld-module--side-data__small-text--uppercase--89a4e";
export var text = "mainOld-module--text--45efc";
export var titleH1 = "mainOld-module--title--h1--9f023";
export var titleH2 = "mainOld-module--title--h2--87baf";
export var titleH3 = "mainOld-module--title--h3--bef09";
export var titleH4 = "mainOld-module--title--h4--4f0f6";